export function getBearerToken() {
  return `Token ${sessionStorage.getItem("token")}`;
}
